const toBool = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const val = value.toLowerCase();
    return val === 'true' || val === 'on' || val === '1';
  }
  return false;
};

const env = {
  NODE_ENV: process.env.NODE_ENV || 'development',
  PUBLIC_URL: process.env.PUBLIC_URL || '',
  BRIZI_API_AUTHORITY: process.env.BRIZI_API_AUTHORITY,
  BRIZI_APP_SLUG: process.env.BRIZI_APP_SLUG || 'demo',
  BRIZI_SECURE: toBool(process.env.BRIZI_SECURE),
  HTTP_PROTOCOL: toBool(process.env.BRIZI_SECURE) ? 'https://' : 'http://',
  WS_PROTOCOL: toBool(process.env.BRIZI_SECURE) ? 'wss://' : 'ws://',
  DASHBOARD_HOST: process.env.BRIZI_API_AUTHORITY ? process.env.BRIZI_API_AUTHORITY.replace('api', 'dashboard') : '',
  BRIZI_ADMIN_USERNAME: process.env.BRIZI_ADMIN_USERNAME,
  BRIZI_ADMIN_PASSWORD: process.env.BRIZI_ADMIN_PASSWORD,
  EVENT_TIMEZONE: process.env.EVENT_TIMEZONE || 'America/Toronto',
  DEBUG: toBool(process.env.DEBUG ?? 'true'),
  ODD_EVEN_MODE: toBool(process.env.ODD_EVEN_MODE || 'false'),
  DEFAULT_SCALE: process.env.DEFAULT_SCALE || '1',
  OTP_TIMEOUT_SECONDS: process.env.OTP_TIMEOUT_SECONDS || '60',
  DASHBOARD_GOOGLEMAPS_API_KEY: process.env.DASHBOARD_GOOGLEMAPS_API_KEY || '',
  USER_APP_TYPE: process.env.USER_APP_TYPE,
  isDev: () => env.NODE_ENV === 'development',
  isProd: () => env.NODE_ENV === 'production',
  isTest: () => env.NODE_ENV === 'test',
  isSelfieCam: () => env.USER_APP_TYPE === 'ai',
};

export default env;
